import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { HeroSection } from '@/components/landing/hero-section'
import { ProofSection } from '@/components/landing/proof-section'
import { WorkflowSection } from '@/components/landing/workflow-section'
import { OversightSection } from '@/components/landing/oversight-section'
import { PerformanceSection } from '@/components/landing/performance-section'
import { ValueSection } from '@/components/landing/value-section'
import { CtaSection } from '@/components/landing/cta-section'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            <HeroSection />
            <ProofSection />
            <WorkflowSection />
            <OversightSection />
            <PerformanceSection />
            <ValueSection />
            <CtaSection />
        </Layout>
    )
}

export default Home
